<template>
    <div v-loading="loading" class="gp-detail-page">
        <template v-if="!loading">
            <section :class="isNewStyle === 1 ? '' : 'gp-detail-page__section'">
                <app-head-pic-video
                    :app-video-info="appVideoInfo"
                    :imgs="appDoc.screen_h"
                />
                <app-show
                    :app-head-data="appHeadData"
                    :head-info="headInfo"
                    :download-info="downloadInfo"
                    :is-reserve-app="isReserveApp"
                    :basic-info="basicInfo"
                    :is-new-style="isNewStyle"
                    @showDownloadDawer="showDownloadDawer"
                />
            </section>
            <section v-if="!!appDoc.desc || screen" class="gp-detail-page__section">
                <app-desc
                    v-if="!!appDoc.desc"
                    :content="appDoc.desc"
                    :pblog-data="pblogData"
                    :max-rows="5"
                    has-title="游戏详情"
                    :is-new-style="isNewStyle"
                    :app-tags="appDoc.tags"
                    :operatetags="appDoc.operate_tags"
                />
                <app-video-show
                    v-if="screen"
                    :imgs="screen"
                    :type="screenDirection"
                    :app-video-info="appVideoInfo"
                />
            </section>
            <section
                v-if="appDoc.officialNews && appDoc.officialNews.list" id="news"
                class="gp-detail-page__section"
            >
                <app-news
                    :app-news-data="appNewsData"
                />
            </section>
            <section
                v-if="!!(updateInfo && updateInfo.version_code) && isNewStyle === 1" id="newfeatures"
                :class="isNewStyle === 1 || !!updateInfo ? 'gp-detail-page__section' : ''"
            >
                <app-desc
                    :pblog-data="pblogData"
                    :update-info="updateInfo"
                    :content="updateContent"
                    :is-new-style="isNewStyle"
                    :max-rows="5"
                    :has-title="'新版特性'"
                />
            </section>
            <section
                v-if="!isReserveApp" id="score"
                :class="isNewStyle === 0 || appDoc.comment_list.length === 0 ? 'gp-detail-page__section' : ''"
            >
                <app-score
                    :app-score-data="appScoreData"
                    :is-new-style="isNewStyle"
                    :comment-info="commentInfo"
                />
            </section>
            <section
                v-if="!!appDoc.comment_list && appDoc.comment_list.length > 0" id="comment"
                class="gp-detail-page__section"
            >
                <app-comment
                    :comment-info="commentInfo"
                    :is-new-style="isNewStyle"
                />
            </section>
            <section v-if="!!basicInfo" class="gp-detail-page__section basic">
                <app-basic
                    :basic="basicInfo"
                    :update-info="updateInfo"
                    :is-new-style="isNewStyle"
                />
            </section>
            <section
                v-if="!!(updateInfo && updateInfo.version_code && isNewStyle !== 1)" id="updateInfoArea"
                class="gp-detail-page__section"
            >
                <app-desc
                    :pblog-data="pblogData"
                    :update-info="updateInfo"
                    :content="updateContent"
                    :max-rows="3"
                    :has-title="'更新信息'"
                />
            </section>
            <div
                v-if="loadAsyncComponents && recommend && recommend.samegame && recommend.samegame.length"
                id="firstRecommend"
                class="bottom-line"
            >
                <app-recommend
                    class="gp-detail-page__section"
                    :pblog-data="pblogData"
                    :title="isNewStyle === 1 ? '猜你爱玩' : '玩过这款游戏的还会玩'"
                    :app-list="recommend.samegame"
                    :is-new-style="isNewStyle"
                />
            </div>
            <div v-if="recommend && loadAsyncComponents">
                <app-recommend
                    v-if="recommend.samegame && recommend.samecompany.length"
                    class="gp-detail-page__section"
                    :pblog-data="pblogData"
                    :title="isNewStyle === 1 ? '同厂商游戏' : '来自开发者'"
                    :app-list="recommend.samecompany"
                    :is-new-style="isNewStyle"
                />
                <app-recommend
                    v-if="recommend.samegame && recommend.newgame.length"
                    class="gp-detail-page__section"
                    :pblog-data="pblogData"
                    :title="isNewStyle === 1 ? '近期新游' : '发现有趣新游'"
                    :app-list="recommend.newgame"
                    :is-new-style="isNewStyle"
                />
            </div>
            <section
                v-if="isNewStyle === 1 && appDoc.included_rank && appDoc.included_rank.length > 0"
                class="topline"
            >
                <hot-rank
                    :app-name="appDoc.app_name"
                    :app-type="appDoc.app_type"
                    :app-id="appDoc.app_id"
                    :rank-list="appDoc.included_rank.slice(0, 6)"
                    :fromnewdetail="1"
                />
            </section>
            <div>
                <app-download-sticky
                    v-if="!isReserveApp"
                    :download-info="downloadInfo"
                    :basic-info="basicInfo"
                    :need-bottom="true"
                    position="bottomFixed"
                    :is-new-style="isNewStyle"
                    @showDownloadDawer="showDownloadDawer"
                />
                <app-reserve
                    v-else
                    :app-doc="downloadInfo"
                    :need-bottom="true"
                    position="bottomFixed"
                />
            </div>
            <!-- </template> -->
        </template>
        <div
            v-if="showGuideLayer" class="guide-layer"
            @click="hideGuideLayer"
        >
            <section class="arrow"></section>
            <section class="browserIcon"></section>
            <section class="descText">请点击右上角【...】用浏览器打开</section>
        </div>
        <div v-if="showDownload && recDownloadGame.length > 0">
            <download-recommend
                :app-name="appDoc.app_name"
                :app-type="downloadInfo.app_type"
                :show-download="showDownload"
                :rec-download-game="recDownloadGame"
                :resume-download="resumeDownload"
                @closeDownloadDrawer="closeDownloadDrawer"
                @showWifiToast="showWifiToast"
            />
        </div>
        <div v-if="showWifiBox && recDownloadGame.length > 0" class="wifiTipsBox">
            <wifiTipsBox
                :show-wifi-box="showWifiBox"
                @closeWifiBox="closeWifiBox"
                @resumeDownloadClick="resumeDownloadClick"
            />
        </div>
    </div>
</template>

<script>
import AppDesc from './components/app-desc';
import AppVideoShow from './components/app-videoshow';
import AppShow from './components/app-headshow';
import api from '@/api';
import {on} from '@/utils/dom';
import {throttle, debounce} from 'throttle-debounce';
import {getQueryString, getUrlParams} from '@/utils/url';
import bus from './bus/bus';
import AppReserve from './components/app-reserve';
import AppDownloadSticky from './components/app-download-sticky';
import {performanceMonitor, downloadApk} from '@/utils/browser';
import AppAchievement from './components/app-achievement.vue';
import HotRank from '@/pages/gamerank/components/hot-rank.vue';
import DownloadRecommend from './components/app-download-recommend.vue';
import wifiTipsBox from './components/app-wifi-tips-box.vue';
import AppHeadPicVideo from './components/app-head-pic-video.vue';

export default {
    components: {
        AppDesc,
        AppVideoShow,
        AppRecommend: () => import(/* webpackChunkName: 'newdetail-scoll' */ './components/app-recommend'),
        AppShow,
        AppBasic: () => import(/* webpackChunkName: 'newdetail-fpReady' */ './components/app-basic'),
        AppScore: () => import(/* webpackChunkName: 'newdetail-fpReady' */ './components/app-score'),
        AppNews: () => import(/* webpackChunkName: 'newdetail-fpReady' */ './components/app-news'),
        AppComment: () => import(/* webpackChunkName: 'newdetail-fpReady' */ './components/app-comment'),
        AppDownloadSticky,
        AppReserve,
        AppAchievement,
        HotRank,
        DownloadRecommend,
        wifiTipsBox,
        AppHeadPicVideo,
    },
    data() {
        return {
            loading: true,
            showGuideLayer: false,
            appDoc: null,
            recommend: null,
            recDownloadGame: null,
            screen: null,
            screenDirection: '',
            headInfo: {
                headPicture: '',
                marks: [],
                tags: [],
                title: '',
            },
            basicInfo: null,
            updateInfo: null,
            updateContent: '',
            once: true,
            updateOnce: true,
            isReserveApp: false,
            scoreMark: null,
            commentInfo: null,
            pblogData: null,
            downloadInfo: null,
            appHeadData: null,
            appNewsData: null,
            appScoreData: null,
            appVideoInfo: null,
            loadAsyncComponents: false, // 加载异步组件
            titleType: '',
            rankList: {},
            isNewStyle: 0,
            showDownload: false,
            showWifiBox: false,
            resumeDownload: false,
        };
    },
    watch: {
        showGuideLayer: {
            handler(val) {
                this.scrollOrNot(val);
            },
        },
    },
    created() {
        this.showDisplayLogFun = debounce(500, () => {
            this.doDisplayLog();
        });
        on(window, 'scroll', () => {
            this.showDisplayLogFun();
        });
        this.checkNewStyle();
    },
    mounted() {
        this.initRequest();
        if (getQueryString('location') === 'news') {
            setTimeout(() => {
                let newsDom = document.getElementById('news');
                let offsetY = 0;
                if (newsDom) {
                    offsetY = newsDom.offsetTop;
                }
                window.scrollTo(0, offsetY);
            }, 500);
        }
        if (getQueryString('location') === 'comment') {
            setTimeout(() => {
                let commentDom = document.getElementById('comment');
                let offsetY = 0;
                if (commentDom) {
                    offsetY = commentDom.offsetTop - 60;
                }
                window.scrollTo(0, offsetY);
            }, 500);
        }
        bus.$on('showGuideLayer', data => {
            this.showGuideLayer = data;
        });
        this.$nextTick(() => {
            on(window, 'scroll', throttle(200, this.scrollCallback));
        });
    },
    methods: {
        async initRequest() {
            this.loading = true;
            const {appid, channelid, sid, zoneAppId, cid} = getUrlParams();
            this.appid = appid;
            let params = {
                appid,
                channelid,
                zoneAppId,
            };
            let dParams = {
                data: {
                    appid,
                    channelid,
                    from_new_detail: true,
                    'page_name': 'AldDetailPageH5',
                    zoneAppId,
                    cid,
                },
            };
            if (!appid || !channelid) {
                return;
            }
            const p1 = api.newdetail.getGameInfo(dParams).catch(err => {
                console.log(err);
            });
            const p2 = api.newdetail.getRecommendGames(params).catch(err => {
                console.log(err);
            });
            const p3 = api.newdetail.getDownloadRecGames({data: {app_id: appid, channelid, sid}}).catch(err => {
                console.log(err);
            });
            const [appDoc, recommend, recDownloadGame] = await Promise.all([p1, p2, p3]);
            this.initData(appDoc, recommend);
            this.recDownloadGame = recDownloadGame.samegame;
            this.loading = false;
        },
        initData(appDoc, recommend) {
            this.appDoc = appDoc || {};
            if (recommend) {
                this.recommend = recommend;
            }
            if (this.appDoc.book_status !== undefined && +appDoc.book_status !== 2) {
                this.isReserveApp = true;
            }
            const {
                screen_v,
                screen_h,
                app_name,
                icon_url,
                tags,
                version_list,
                version_name,
                dev,
                publisher,
                buy_ins,
                ads_has,
                network,
                app_size,
                privacy,
                permission,
                package_name,
                app_id = this.appid,
                app_type,
                comment_count,
                comment_list,
                logo,
                download_url,
                ios_url,
                zone_appid,
                book_status,
                officialNews,
                mark,
                poster,
                video,
                date,
                dev_mod_time,
                download_button_name,
                operate_tags,
                miitInfo,
                booked_num,
                download_num,
            } = appDoc;
            this.basicInfo = Object.freeze({
                dev,
                publisher,
                buy_ins,
                ads_has,
                network,
                app_size,
                privacy,
                permission,
                package_name,
                app_id,
                app_type,
                app_name,
                dev_mod_time: dev_mod_time ? dev_mod_time.split(' ')[0] : '',
                version_name,
                operate_tags,
                miitInfo,
            });
            this.commentInfo = Object.freeze({
                comment_count,
                comment_list,
                package_name,
                app_id,
                app_type,
                app_name,
            });
            this.headInfo = Object.freeze({
                headPicture: icon_url,
                marks: ads_has ? ['官方', '安全'] : ['官方', '安全', '无广告'],
                tags,
                title: app_name,
            });
            this.pblogData = {
                package_name,
                app_id,
                app_type,
                app_name,
            };
            this.downloadInfo = Object.freeze({
                logo,
                package_name,
                download_url,
                ios_url,
                app_name,
                app_id,
                app_type,
                zone_appid,
                download_button_name,
                icon_url,
            });
            this.appHeadData = Object.freeze({
                book_status,
                date,
                package_name,
                app_name,
                app_id,
                app_type,
                booked_num,
                download_num,
            });
            this.appNewsData = Object.freeze({
                officialNews,
                ...this.pblogData,
            });
            this.appScoreData = Object.freeze({
                mark,
                ...this.pblogData,
            });
            this.appVideoInfo = {
                poster,
                video,
                ...this.pblogData,
            };
            if (version_list && version_list.length > 0) {
                const version = version_list[0];
                const updateNotes = version && version.update_note;

                this.updateInfo = version;
                this.updateContent = updateNotes && updateNotes.split('\n').join('<br>');
            }
            else {
                this.updateInfo = Object.freeze({
                    version_name,
                });
            }
            document.title = app_name;
            if (screen_v && screen_v.length) {
                this.screen = screen_v;
                this.screenDirection = 'v';
            }
            const {browserVersion, browserName} = window.detailUserAgentInfo;
            this.$root.extData = {
                gameId: app_id,
                gameType: app_type,
                gameName: app_name,
                browserVersion,
                browserName,
                sid: getQueryString('sid') || '',
                srcId: getQueryString('srcid') || '',
                channelid: getQueryString('channelid') || '',
                tid: getQueryString('tid') || '',
                cid: getQueryString('cid') || '',
            };
            this.$nextTick(() => {
                // 发送到达
                if (!window.isSendWiseEndCount) {
                    performanceMonitor('13_96', 'gamepage_detail_new');
                    window.isSendWiseEndCount = true;
                }
                on(window, 'scroll', throttle(200, this.togglePingfenVisible));
                if (getQueryString('isDownload') === '2') {
                    setTimeout(() => {
                        const {logo = '', package_name, download_url} = this.downloadInfo;
                        download_url && downloadApk(download_url, logo, package_name);
                    }, 500);
                }
            });

            // 详情展现页打点
            this.$logger.show({
                type: 'show',
                value: '',
                ext: {
                    item: [
                        {
                            id: this.appDoc.package_name,
                            ext: {
                                gameId: this.appDoc.app_id,
                                gameType: this.appDoc.app_type,
                                gameName: this.appDoc.app_name,
                                sid: getQueryString('sid') || '',
                                srcId: getQueryString('srcid'),
                                channelid: getQueryString('channelid') || '',
                                isNewStyle: this.isNewStyle,
                                tid: getQueryString('tid') || '',
                                cid: getQueryString('cid') || '',
                                game_id: getQueryString('zoneAppId') || '',
                                position: getQueryString('position') || '',
                                fid: getQueryString('fid') || '',
                                fname: getQueryString('fname') || '',
                            },
                            pos: '',
                        },
                    ],
                },
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        scrollOrNot(isScroll) {
            document.body.style.overflow = isScroll ? 'hidden' : '';
        },
        hideGuideLayer() {
            this.showGuideLayer = false;
        },
        togglePingfenVisible() {
            let deviceHeight = window.screen.height;
            let firstRecommend = document.getElementById('firstRecommend');
            let updateInfoArea = document.getElementById('updateInfoArea');
            let reBottom = 0;
            let upBottom = 0;
            if (firstRecommend && firstRecommend.getBoundingClientRect) {
                reBottom = firstRecommend.getBoundingClientRect().bottom;
            }
            if (updateInfoArea && updateInfoArea.getBoundingClientRect) {
                upBottom = updateInfoArea.getBoundingClientRect().bottom;
            }
            if (this.once && reBottom < deviceHeight) {
                this.firstShowRecommend();
                this.once = false;
            }
            if (this.updateOnce && upBottom < deviceHeight) {
                this.firstShowUpdateInfoArea();
                this.updateOnce = false;
            }
        },
        firstShowUpdateInfoArea() {
            this.$logger.display({
                ext: {
                    item: [
                        {
                            id: this.appDoc.package_name,
                            ext: {
                                gameId: this.appDoc.app_id,
                                gameType: this.appDoc.app_type,
                                gameName: this.appDoc.app_name,
                                sid: getQueryString('sid'),
                                srcId: getQueryString('srcid'),
                                channelid: getQueryString('channelid') || '',
                            },
                            pos: '',
                        },
                    ],
                },
                type: 'display',
                value: 'updateNews',
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        firstShowRecommend() {
            this.$logger.showItems({
                ext: {
                    item: [
                        {
                            id: this.appDoc.package_name,
                            ext: {
                                moduleName: this.title,
                                gameId: this.appDoc.app_id,
                                gameType: this.appDoc.app_type,
                                gameName: this.appDoc.app_name,
                                sid: getQueryString('sid'),
                                srcId: getQueryString('srcid'),
                                channelid: getQueryString('channelid') || '',
                            },
                            pos: '',
                        },
                    ],
                },
                type: 'showItems',
                value: '',
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        scrollCallback() {
            if (this.appDoc) {
                this.togglePingfenVisible();
            }
            if (!this.loadAsyncComponents && window.scrollY > 50) {
                this.loadAsyncComponents = true;
            }
        },
        doDisplayLog() {
            this.$logger.inScreen('.pb-show-display', dataset => {
                this.$logger.display(dataset);
            });
        },
        tobasic() {
            let score = document.querySelector('#score');
            if (score) {
                score.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        },
        checkNewStyle() {
            if (getQueryString('isNewStyle') === '1') {
                this.isNewStyle = 1;
            }
            else {
                this.isNewStyle = 0;
            }
        },
        showDownloadDawer(val) {
            this.showDownload = val;
        },
        closeDownloadDrawer(val) {
            this.showDownload = val;
        },
        showWifiToast(val) {
            this.showWifiBox = val;
        },
        closeWifiBox(val) {
            this.showWifiBox = val;
        },
        resumeDownloadClick(val) {
            this.resumeDownload = val;
        },
    },
};

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/border";
    @import "~@/common/style/mixin/mixins";

    $design-width: 1242;
    $max-device-width: 1024px;

    html {
        @include root-font-size();
    }

    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
    }

    body {
        color: #333;
    }
    .bottom-line {
        border-bottom: px2rem(18) solid #f5f5f5;
    }

    @include b(detail-page) {
        padding-bottom: px2rem(300);
        min-height: 100%;
        overflow: hidden;

        .guide-layer{
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            top: 0;
            z-index: 10;
            color: #fff;
            font-size: px2rem(50);
            .arrow{
                width: px2rem(200);
                height: px2rem(250);
                background-image: url('./images/arrow.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                position: absolute;
                top: px2rem(50);
                right: px2rem(100);
            }
            .descText{
                position: absolute;
                width: px2rem(450);
                right: px2rem(300);
                top: px2rem(250);
            }
            .browserIcon{
                width: px2rem(100);
                height: px2rem(100);
                background-image: url('./images/browserIcon.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                position: absolute;
                top: px2rem(280);
                right: px2rem(780);
            }
        }

        @include e(section) {
            width: 100%;
            border-bottom: px2rem(18) solid #f5f5f5;
            background: #fff;

            &:last-child {
                border-bottom: none;
            }
        }
    }
    .mask {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
    }
    .topline {
        border-top: px2rem(18) solid #f5f5f5;
    }

    .float-wrapper {
        position: fixed;
        width: 100%;
        top: 0;
    }
    .wifiTipsBox {
        position: fixed;
        top: 557px;
        left: 125px;
        z-index: 1020;
    }


</style>